export default "__VITE_ASSET__C$uUa4Tn__"